"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var uuid_1 = require("../helpers/uuid");
var ItemContext_1 = require("./ItemContext");
var collapse_1 = __importDefault(require("@prezzee/collapse"));
var theme_1 = require("@prezzee/theme");
var style = __importStar(require("./Accordion.style"));
var tokens_1 = require("@prezzee/tokens");
var AccordionItemPanel = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'accordion__panel' : _b, region = _a.region, id = _a.id, _c = _a.borderTop, borderTop = _c === void 0 ? false : _c, rest = __rest(_a, ["className", "region", "id", "borderTop"]);
    var theme = (0, theme_1.useTheme)();
    var renderChildren = function (_a) {
        var _b, _c;
        var panelAttributes = _a.panelAttributes, expanded = _a.expanded, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d;
        if (id) {
            (0, uuid_1.assertValidHtmlId)(id);
        }
        var attrs = __assign(__assign({}, panelAttributes), { 'aria-labelledby': region ? panelAttributes['aria-labelledby'] : undefined });
        var backgroundColor = ((_c = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.accordions[variant]) === null || _c === void 0 ? void 0 : _c.panelBackgroundColor) || tokens_1.colors.white;
        return ((0, jsx_runtime_1.jsx)(collapse_1.default, __assign({ visible: expanded, timeout: 5350, css: style.backgroundStyle(backgroundColor) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ "data-accordion-component": "AccordionItemPanel", className: className, css: style.panel(backgroundColor, borderTop) }, rest, attrs, { role: region ? 'region' : undefined })) })));
    };
    return (0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: renderChildren });
};
exports.default = AccordionItemPanel;
//# sourceMappingURL=AccordionItemPanel.js.map